export const REQUEST_SEARCH = 'roles/REQUEST_SEARCH';
export const RECEIVE_SEARCH = 'roles/RECEIVE_SEARCH';
export const CLEAR_SEARCH = 'roles/CLEAR_SEARCH';
